import { Link } from "react-router-dom";
import { ArrowRight, MessageCircle, Phone } from "lucide-react";
import { waLink, telLink } from "../../lib/brand";

// Big premium conversion CTA
export default function CTASection() {
  return (
    <section
      data-testid="cta-section"
      data-on-dark
      className="relative py-24 md:py-40 bg-ink text-white overflow-hidden grain"
    >
      <div
        className="absolute inset-0 opacity-15 kenburns"
        style={{
          backgroundImage:
            "url('https://customer-assets-jai6qajn.emergentagent.net/job_painter-showcase-v1/artifacts/707tihzb_Screenshot%202026-08-16%20092022.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/85 to-ink/60" />
      <div className="relative max-w-[1200px] mx-auto px-5 md:px-8 text-center">
        <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-white/60 mb-6">
          Ready when you are
        </div>
        <h2 className="font-display text-4xl sm:text-5xl md:text-7xl leading-[1.02] tracking-[-0.035em] max-w-4xl mx-auto">
          Have a flooring, waterproofing or{" "}
          <span className="font-serif-italic font-normal text-white/75">
            painting requirement?
          </span>
        </h2>
        <p className="mt-6 max-w-2xl mx-auto text-white/70 text-base md:text-lg">
          Tell us about your project. Our team can inspect the site and
          recommend a suitable solution.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Link
            to="/contact?service=inspection"
            data-testid="cta-inspection-button"
            className="group inline-flex items-center gap-3 bg-white hover:bg-white/90 text-ink px-8 py-4 text-[11px] tracking-[0.25em] uppercase transition-colors"
          >
            Get Free Site Inspection
            <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
          </Link>
          <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="cta-whatsapp-button"
            className="inline-flex items-center gap-2 border border-white/40 hover:bg-white/10 text-white px-6 py-4 text-[11px] tracking-[0.25em] uppercase transition-colors"
          >
            <MessageCircle size={14} /> WhatsApp Us
          </a>
          <a
            href={telLink()}
            data-testid="cta-call-button"
            className="inline-flex items-center gap-2 border border-white/40 hover:bg-white/10 text-white px-6 py-4 text-[11px] tracking-[0.25em] uppercase transition-colors"
          >
            <Phone size={14} /> Call Now
          </a>
        </div>
      </div>
    </section>
  );
}
